import clsx from 'clsx';
import React from 'react';
import { ComponentSize } from '../../../types';
import { ButtonColor, ButtonVariant } from '../Button';
import { ButtonGroupProps } from './ButtonGroup.types';

const ButtonGroup = ({
  children,
  className,
  disabled: disabledProp,
  fullWidth,
  loading: loadingProp,
  size = ComponentSize.SMALL,
}: ButtonGroupProps) => {
  return (
    <div className={clsx('flex h-fit flex-row-reverse gap-2', fullWidth && 'w-full', className)}>
      {React.Children.map(children as React.ReactElement[], (child, index) => {
        // If the button group is loading,
        // disable all buttons and only show the loading state on the first button.
        const disabled = (index !== 0 && loadingProp) || disabledProp;
        const loading = index === 0 && loadingProp;

        // Variant and color defaults for 2 buttons
        const variant = index === 0 ? ButtonVariant.STRONG : ButtonVariant.SOFT;
        const color = index === 0 ? ButtonColor.PRIMARY : ButtonColor.NEUTRAL;

        return React.cloneElement(child, {
          color,
          size,
          variant,
          disabled,
          fullWidth,
          loading,
          ...child.props, // Child props should override default styles.
        });
      })}
    </div>
  );
};

export default ButtonGroup;
